// @flow
import * as React from 'react';
import { injectIntl } from 'react-intl';
// eslint-disable-next-line import/named
import type { IntlShape } from 'react-intl';

// Components
import { Container, Row, Col } from 'reactstrap';
import ErrorPanel from 'components/atoms/ErrorPanel';

// utils
import { isTrue, undefinedToTrue } from 'utils/varValidation';

import './StatusTrackerError.scss';

const ns = 'status-tracker-error';

export type Props = {
  intl: IntlShape,
  statusTrackerData: Object
};

const StatusTrackerError = ({ intl, statusTrackerData }: Props) => {
  const errorInfo = {
    mainErrorMessageId: 'c8.status.tracker.error.oops',
    errorMessageId: isTrue(
      undefinedToTrue(statusTrackerData.statusTrackerEnabled)
    )
      ? 'c8.status.tracker.something.went.wrong.please.try.again.later'
      : 'c8.status.tracker.your.dealer.no.longer.supports.service.tracker'
  };
  return (
    <Container>
      <Row>
        <Col>
          <h1 className={`${ns}__title my-3`}>
            {intl.formatMessage({
              id: 'c8.status.tracker.service.tracker'
            })}
          </h1>
        </Col>
      </Row>
      <ErrorPanel errorInfo={errorInfo} />
    </Container>
  );
};

export default injectIntl(StatusTrackerError);



// WEBPACK FOOTER //
// ./src/components/pages/StatusTrackerError/StatusTrackerError.js